import types from "../actionTypes";

export default (
  state = {
    currentPage: 1,
    pageSize: 10,
    totalRows: 0,
    attachments: [],
    isCustomAttachment: false,
    caseStatusDeatils: [],
  },
  action
) => {
  switch (action.type) {
    case types.SET_ATTACHMENTS:
      return Object.assign({}, state, { attachments: action.attachments });
    case types.SET_TOTAL_ROWS:
      return Object.assign({}, state, { totalRows: action.totalRows });
    case types.SET_CURRENT_PAGE:
      return Object.assign({}, state, { currentPage: action.currentPage });
    case types.SET_PAGE_SIZE:
      return Object.assign({}, state, { pageSize: action.pageSize });
    case types.IS_CUSTOM_ATTACHMENT:
      return Object.assign({}, state, {
        isCustomAttachment: action.isCustomAttachment,
      });
    case types.SET_CASE_DETAILS_BY_EIN:
      return Object.assign({}, state, {
        caseStatusDeatils: action.caseStatusDeatils,
      });

    default:
      return state;
  }
};
